const SectionHeading = ({
  eyebrow,
  title,
  description,
  titleClassName = "text-foreground",
  descriptionClassName = "text-muted-foreground",
  eyebrowClassName = "text-primary",
}: {
  eyebrow?: string;
  title: string;
  description?: string;
  titleClassName?: string;
  descriptionClassName?: string;
  eyebrowClassName?: string;
}) => (
  <div className="max-w-3xl mx-auto text-center mb-12 md:mb-16">
    {eyebrow ? (
      <p
        className={`text-sm font-semibold uppercase tracking-[0.3em] mb-4 ${eyebrowClassName}`}
      >
        {eyebrow}
      </p>
    ) : null}
    <h2
      className={`text-3xl md:text-4xl font-bold leading-tight ${titleClassName}`}
    >
      {title}
    </h2>
    {description ? (
      <p className={`mt-4 text-lg ${descriptionClassName}`}>{description}</p>
    ) : null}
  </div>
);

export default SectionHeading;
